import { combineReducers } from 'redux';
import { ExpertiseWidgetState } from './ExpertiseWidgetState';
import { ExpertiseActionPayload } from './actions';
import { expertiseStreamReducer } from './stream/reducer';
import { WidgetType } from 'widgets/WidgetType';
import { ExpertiseWidgetType } from '../ExpertiseWidgetStrategy';
import { expertiseConfigReducer } from './configuration/reducer';
import { createComponentStateReducer } from 'widgets/store/component/reducer';
import {
    ExpertiseComponentState,
    initialExpertiseComponentState,
} from 'widgets/expertise/store/component/ExpertiseComponentState';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const widgetStateReducer = (widgetType: ExpertiseWidgetType) =>
    combineReducers<ExpertiseWidgetState>({
        component: createComponentStateReducer<ExpertiseComponentState>(
            initialExpertiseComponentState
        ),
        stream: expertiseStreamReducer,
        config: expertiseConfigReducer(widgetType),
    });

const createExpertiseReducer = (widgetType: ExpertiseWidgetType) =>
    createWidgetsReducer<ExpertiseWidgetState, ExpertiseActionPayload>(
        widgetType,
        widgetStateReducer(widgetType)
    );

export const expertiseMakeWidgetsReducer = createExpertiseReducer(
    WidgetType.EXPERTISE_MAKE
);

export const expertiseNighthawkWidgetsReducer = createExpertiseReducer(
    WidgetType.EXPERTISE_NIGHTHAWK
);

export const expertiseDnaWidgetsReducer = createExpertiseReducer(
    WidgetType.EXPERTISE_DNA
);
